import { render, staticRenderFns } from "./CreateTemplates.vue?vue&type=template&id=7c5042bd&scoped=true"
import script from "./CreateTemplates.vue?vue&type=script&lang=js"
export * from "./CreateTemplates.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplates.vue?vue&type=style&index=0&id=7c5042bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5042bd",
  null
  
)

export default component.exports